const formatHourRange = (hourStart: number, hourEnd: number, name?: string) => {
  if (name?.trim()) return name.trim();
  return `${hourStart}:00-${hourEnd}:00`;
};

const formatTransportEta = (
  interval: unknown,
  eta?: unknown
): string | null => {
  if (typeof eta === 'string' && eta.trim()) {
    return eta.trim();
  }

  if (interval == null) return null;

  if (typeof interval === 'string') {
    const trimmed = interval.trim();
    if (!trimmed) return null;

    const hourRangeMatch = trimmed.match(/^(\d{1,2})-(\d{1,2})$/);
    if (hourRangeMatch) {
      return formatHourRange(
        Number(hourRangeMatch[1]),
        Number(hourRangeMatch[2])
      );
    }

    return trimmed;
  }

  if (typeof interval === 'object') {
    const value = interval as Record<string, unknown>;
    const name = typeof value.name === 'string' ? value.name : undefined;
    const hourStart = value.hourStart ?? value.hour_start;
    const hourEnd = value.hourEnd ?? value.hour_end;

    if (typeof hourStart === 'number' && typeof hourEnd === 'number') {
      return formatHourRange(hourStart, hourEnd, name);
    }

    if (name?.trim()) return name.trim();
  }

  return null;
};

export { formatTransportEta };
